import {approval} from './govern';
import {isv} from './opinion';
import {S} from './state';
import {clamp,de} from './util';
import {IND,INDM,ISS2IND} from '../content/indicators';
export {IND,INDM,ISS2IND};

export const et=(id:string):number=>(S.etat||{})[id]||0;

/** Formeln der Kennzahlen: lesen Problemdruck, Etat und Zustand. */
export const INDF:Record<string,()=>number>={
 leben:()=>81.2+(50-(isv('gkv')+isv('pflege')+isv('aerzte'))/3)*.025+et('ge')*.03,
 warte:()=>Math.max(5,35+((isv('gkv')+isv('aerzte'))/2-49)*.7-et('ge')*.8),
 pisa:()=>475+(50-isv('bildung'))*1.6+et('bf')*2-(isv('kinderarmut')-52)*.5,
 wohn:()=>Math.max(0,700+(isv('wohnen')-62)*14-et('bw')*15),
 insol:()=>Math.max(8000,21500-(S.gr-1)*4000+(isv('energie')-52)*70+(isv('insolvenz')-50)*140+(isv('steuer')-45)*40-et('wi')*300),
 gruend:()=>Math.max(200,560+(S.gr-1)*30-(isv('digital')-42)*1.5-(isv('steuer')-45)+et('wi')*4+et('dg')*5),
 co2:()=>Math.max(120,590-S.m/12*6+(isv('klima')-48)*2.5-(S.ind&&S.lte?0:0)),
 krimi:()=>6800+(isv('sicher')-44)*35+(isv('asyl')-52)*8-et('in')*40,
 armut:()=>Math.max(5,16.6+(isv('kinderarmut')-52)*.04+(S.al-6.2)*.5+(isv('preise')-49)*.03-et('as')*.08),
 bahn:()=>clamp(64+(60-isv('infra'))*.35+et('vk')*.6,30,95),
 strom:()=>Math.max(15,38+(isv('energie')-52)*.3),
 fachl:()=>Math.max(50,530+(isv('fach')-58)*12-(S.al-6.2)*20),
 vertr:()=>clamp(52+(approval()-45)*.5-(isv('laendlich')-47)*.1+(S.press||0)*.5,15,85),
};


export function initInd(){S.ind={};S.hist={};IND.forEach((x:any)=>{S.ind[x.id]=INDF[x.id]();S.hist[x.id]=[S.ind[x.id]]});S.ind0={...S.ind}}
export function updInd(){IND.forEach((x:any)=>{S.ind[x.id]+=(INDF[x.id]()-S.ind[x.id])*x.a;if(S.m%2===0){const h=S.hist[x.id];h.push(S.ind[x.id]);if(h.length>120)h.shift()}})}
export const fmtInd:any=(x:any,v:any)=>(x.d?de(v,x.d):Math.round(v).toLocaleString('de-DE'))+x.u;
export function indGood(x?:any,from?:any,to?:any){const d=to-from;return Math.abs(d)<1e-9?0:(d>0)===x.up?1:-1}
export function indDelta(id?:any){const x=INDM[id];if(!S.ind0||!S.ind)return 0;const a=S.ind0[id],b=S.ind[id];return (b-a)/Math.max(1,Math.abs(a))*(x.up?1:-1)}
export function fmtDelta(x:any,d:number){if(Math.abs(d)<(x.d?.05:.5))return '±0';return (d>0?'+':'−')+(x.d?de(Math.abs(d),x.d):Math.round(Math.abs(d)).toLocaleString('de-DE'))}
